import paths from "./routes";
import { ReactElement } from "react";
import NotebookPage from "./pages/NotebookPage";
import NotebooksPage from "./pages/NotebooksPage";
import StudentsAllProjectsPage from "./pages/StudentsAllProjectsPage";
import DatasetsPage from "./pages/DatasetsPage";
import StudentDashboard from "./pages/StudentDashboard";
import PythonScriptsPage from "./pages/PythonScriptsPage";
import ProjectDetailsPage from "./pages/ProjectDetailsPage";
import CourseDetailsPage from "./pages/CourseDetailsPage";
import PageContentPage from "./pages/PageContentPage";
import LessonPage from "./pages/LessonPage";
import BookPage from "./pages/BookPage";
import { useLocation } from "react-router-dom";

export interface AppRoute {
  path?: string;
  element: ReactElement;
  name: string;
  index?: boolean;
}

const studentRoutes: AppRoute[] = [
  { path: paths.notebook, element: <NotebookPage />, name: "Notebook" },
  { path: paths.notebooks, element: <NotebooksPage />, name: "Notebooks" },
  {
    path: paths.pythonScripts,
    element: <PythonScriptsPage />,
    name: "Scripts",
  },
  {
    path: paths.allProjects,
    element: <StudentsAllProjectsPage />,
    name: "All Projects",
  },
  { path: paths.datasets, element: <DatasetsPage />, name: "Datasets" },
  { path: paths.courseDetails, element: <CourseDetailsPage />, name: "Course Details" },
  { path: paths.pageContent, element: <PageContentPage />, name: "Page Content" },
  { path: paths.lessonContent, element: <LessonPage />, name: "Lesson Content" },
  { path: paths.bookContent, element: <BookPage />, name: "Book Content" },
  { element: <StudentDashboard />, name: "Dashboard", index: true },
  {
    path: paths.projectDetails,
    element: <ProjectDetailsPage />,
    name: "Project Details",
  },
];

export default studentRoutes;
